import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e1884e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dictionary templates" }
const _hoisted_2 = {
  key: 0,
  class: "legend d-flex flex-row justify-content-around mb-3"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div data-v-19e1884e><i class=\"fas fa-square\" data-v-19e1884e></i> Unselected </div><div data-v-19e1884e><i class=\"fas fa-square\" data-v-19e1884e></i> Default </div><div data-v-19e1884e><i class=\"fas fa-square\" data-v-19e1884e></i> Unfurnished </div><div data-v-19e1884e><i class=\"fas fa-square\" data-v-19e1884e></i> Part furnished </div><div data-v-19e1884e><i class=\"fas fa-square\" data-v-19e1884e></i> Fully furnished </div><div data-v-19e1884e><i class=\"fas fa-square\" data-v-19e1884e></i> Fully furnished with linen </div>", 6)
const _hoisted_9 = [
  _hoisted_3
]
const _hoisted_10 = {
  key: 1,
  class: "card"
}
const _hoisted_11 = { class: "card-body p-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "templateicon no-template" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "templateicon no-template" }, null, -1))

import { computed } from 'vue';
import _ from 'lodash';
import { useStore } from 'vuex';
import { DictionaryType, DictionaryRoom } from '@/models';
import { DictionaryState } from '@/store/dictionary/types';
import SectionTypeSelector from './partials/SectionTypeSelector.vue';
import TemplateSelectModal from "@/components/modals/TemplateSelectModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DictionaryTemplates',
  setup(__props) {

const store = useStore();

const dictionaryState = computed(() => store.state.dictionary as DictionaryState);
const hasActiveSection = computed(() => store.getters['dictionary/hasActiveSection'] as boolean);
const currentTypes = computed(() => store.getters['dictionary/currentTypes'] as DictionaryType[]);
const roomsByPriority = computed(() => store.getters['dictionary/roomsByPriority'] as DictionaryRoom[]);
const setActiveType = async (type: DictionaryType) => {
   store.commit('dictionary/setActiveType', type);
};

const setActiveRoom = async (room: DictionaryRoom) => {
   store.commit('dictionary/setActiveRoom', room);
};

const setActiveRoomCategory = async (category: number) => {
  store.commit('dictionary/setActiveRoomCategory', category);
};
const isRoomTemplate = (room: DictionaryRoom, type: DictionaryType, furnishStatusMask: number) => {
  const currentRoom = _.find(
    dictionaryState.value.current.rooms,
    (curr: DictionaryRoom) => room.name === curr.name
  );
  
  if (!currentRoom) {
    return false;
  }
  
  const sectionSlug = _.get(dictionaryState.value.activeSection, 'slug');
  if (!sectionSlug) {
    return false;
  }
  
  const slug = `${sectionSlug}/${type.slug}`;
  const hasSlug = _.has(currentRoom.types, slug);
  const flagOn = currentRoom.types[slug] & furnishStatusMask;
  return Boolean(hasSlug && flagOn);
};

const showRoomModal = ($event: Event, type: DictionaryType, room: DictionaryRoom) => {
  setActiveType(type);
  setActiveRoom(room);
  setActiveRoomCategory(0);
};

const showCategoryModal = ($event: Event, type: DictionaryType, category: number) => {
  setActiveType(type);
  setActiveRoom(new DictionaryRoom());
  setActiveRoomCategory(category);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SectionTypeSelector, {
      showSections: true,
      showTypes: false,
      showItems: false
    }),
    (hasActiveSection.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_9))
      : _createCommentVNode("", true),
    (hasActiveSection.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", null, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4], (category) => {
                    return _createElementVNode("td", {
                      key: category,
                      class: "rotate"
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, "CAT " + _toDisplayString(category), 1)
                        ])
                      ])
                    ])
                  }), 64)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomsByPriority.value, (room) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: room.name,
                      class: "rotate"
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(room.name), 1)
                      ])
                    ]))
                  }), 128))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTypes.value, (type) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: type.getSystemName()
                  }, [
                    _createElementVNode("td", null, _toDisplayString(type.getSystemName()), 1),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4], (category) => {
                      return _createElementVNode("td", {
                        key: category,
                        class: "templatecell",
                        onClick: ($event: any) => (showCategoryModal($event, type, category)),
                        "data-toggle": "modal",
                        "data-target": "#template-select-modal"
                      }, _hoisted_15, 8, _hoisted_13)
                    }), 64)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomsByPriority.value, (room) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: room.name,
                        class: "templatecell",
                        onClick: ($event: any) => (showRoomModal($event, type, room)),
                        "data-toggle": "modal",
                        "data-target": "#template-select-modal"
                      }, [
                        _hoisted_17,
                        _createElementVNode("div", {
                          class: _normalizeClass(["templateicon", { furnish0: isRoomTemplate(room, type, 1) }])
                        }, null, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["templateicon", { furnish1: isRoomTemplate(room, type, 2) }])
                        }, null, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["templateicon", { furnish2: isRoomTemplate(room, type, 4) }])
                        }, null, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["templateicon", { furnish3: isRoomTemplate(room, type, 8) }])
                        }, null, 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["templateicon", { furnish4: isRoomTemplate(room, type, 16) }])
                        }, null, 2)
                      ], 8, _hoisted_16))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(TemplateSelectModal)
  ]))
}
}

})